<template>
  <div class="kexue">
    <div class="ipbox">
      <titleCard title="Advertisement of hospital departments"></titleCard>
      <div class="title-text">Sharing medical information and spread of health knowledge, Branding selected hospital departments, Providing a wealth of online experience and professional service, We will continue to make patients feel pleased.
      </div>
      <div class="PCbox">
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <img src="../../assets/image/innovatc/kexue1.webp">
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>01</h2>
            <h3>Propaganda film</h3>
            <p class="bottom">Branding the hospital department with a impressive story line, passively developing the strength of emotional connection in advertising. These storylines are basically emphasizing ones like “dramatic story,” “powerful history,” “love the storyline” and “tells a meaningful story”. A full service video production solution will be carried out including strategy, creative, production, post production, sound track, photography and graphic design etc. </p>
          </div>
        </div>
        <div class="brief-box">
          <div class="box-txt boxstyle animate__animated wow animate__fadeInLeft">
            <h2>02</h2>
            <h3>Creative short films</h3>
            <p class="bottom">The basic approach was to keep the film relatively short and succinct rather than adding many more storylines, more like a documentary, usually lasting a mere 3-5 minutes, easy to share via any social media network with high speed, wide coverage.</p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <img src="../../assets/image/innovatc/kexue2.webp">
          </div>
        </div>
      </div>
      <div class="IosBox">
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="../../assets/image/innovatc/kexue1.webp">
          </div>
          <div class="txt">
            <div class="left">
              <h2>01</h2>
            </div>
            <div class="right">
              <h3>Propaganda film</h3>
              <p>Branding the hospital department with a impressive story line, passively developing the strength of emotional connection in advertising. These storylines are basically emphasizing ones like “dramatic story,” “powerful history,” “love the storyline” and “tells a meaningful story”. A full service video production solution will be carried out including strategy, creative, production, post production, sound track, photography and graphic design etc.</p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="../../assets/image/innovatc/kexue2.webp">
          </div>
          <div class="txt">
            <div class="left">
              <h2>02</h2>
            </div>
            <div class="right">
              <h3>Creative short films</h3>
              <p>The basic approach was to keep the film relatively short and succinct rather than adding many more storylines, more like a documentary, usually lasting a mere 3-5 minutes, easy to share via any social media network with high speed, wide coverage.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="case animate__animated wow animate__fadeIn">
      <titleCard title="Example"></titleCard>
      <div class="case-title">
        2022 Mar 10th the world kidney day. 《New Kidney New Life》A film by PKUPH. A Documentary of Patients with Renal Disease.
      </div>
      <div class="case-title-ios">
        2022 Mar 10th the world kidney day. 《New Kidney New Life》A film by PKUPH. A Documentary of Patients with Renal Disease.
      </div>
      <div class="case-box">
        <el-carousel arrow="always" :autoplay='false' @change="cutChange">
          <el-carousel-item v-for="item in caseList" :key="item.id">
            <video width="100%" height="100%" controls ref="video" autoplay v-if="item.show">
              <source :src="item.url" type="video/mp4">
              <source src="movie.ogg" type="video/ogg">
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="../../assets/image/innovatc/cover.png" alt="">
              <div class="btn" @click="AutoPlay(item.id)"></div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <footerCard name="Mr Wu" phone="138-1097-5144"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {
      caseList: [{
        id: 1,
        url: 'https://yyt-ows.oss-cn-beijing.aliyuncs.com/video/5905bb20-1811dc3f92b.mp4',
        show: false
      }]
    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {
  },
  methods: {
    cutChange() {
      if (this.$refs.video[0]) {
        this.$nextTick(() => {
          this.$refs.video[0].pause()

        })
      }
      if (this.$refs.video[1]) {
        this.$nextTick(() => {
          this.$refs.video[1].pause()

        })
      }
    },
    AutoPlay(id) {
      if (id === 1) {
        this.caseList[0].show = true
      } else {
        this.caseList[1].show = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.kexue {
  .ipbox {
    padding: 1.3684rem 0 1.5789rem 0;
    .title-text {
      color: #272b2d;
      font-size: 0.2526rem;
      text-align: center;
      padding: 0.5263rem 0 0;
      width: 60%;
      margin: 0 auto;
      @media screen and (max-width: 540px) {
        width: 80%;
        font-size: 13px;
        line-height: 22px;
        padding: 30px 0;
      }
    }
    .PCbox {
      @media screen and (max-width: 540px) {
        display: none;
      }
      .brief-box {
        padding-top: 1.0526rem;
        display: flex;
        height: 5.8421rem;
        .box-img {
          width: 50%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .boxstyle {
          // padding-left: 1.3158rem !important;
        }
        .box-txt {
          width: 50%;
          box-sizing: border-box;
          padding-left: 1.5789rem;
          .bottom {
            padding-bottom: 0.1053rem;
            padding-right: 0.5rem;
          }
          h2 {
            padding-top: 0.2rem;
            margin: 0;
            color: #0ca6eb;
            font-size: 0.6421rem;
            font-weight: 700;
            position: relative;
          }
          h2::after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: '';
            width: 0.2105rem;
            height: 0.0526rem;
            background-color: #0ca6eb;
          }
          h3 {
            margin: 0;
            padding: 0.3895rem 0 0.5053rem 0;
            color: #000000;
            font-size: 0.4211rem;
          }
          p {
            color: #333333;
            line-height: 0.4011rem;
            font-size: 0.2526rem;
          }
        }
      }
    }
    .IosBox {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .box {
        padding: 0 15px;
        padding-top: 48px;
        .pic {
          width: 100%;
          height: 223px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .txt {
          padding-top: 15px;
          display: flex;
          .left {
            padding-right: 11px;
            h2 {
              position: relative;
              color: #0ca6eb;
              font-size: 30px;
              margin: 0;
            }
            h2::after {
              position: absolute;
              left: 9px;
              bottom: -2px;
              content: '';
              width: 18px;
              height: 3px;
              background-color: #0ca6eb;
            }
          }
          .right {
            flex-wrap: wrap;
            h3 {
              color: #000;
              font-size: 16px;
              margin: 0;
              padding-top: 8px;
              margin-bottom: 10px;
            }
            p {
              color: #333;
              font-size: 14px;
              padding-right: 15px;
              padding-bottom: 15px;
            }
          }
        }
      }
    }
  }
  // 案例走马灯
  .case {
    .case-title {
      @media screen and (max-width: 540px) {
        display: none;
      }
      text-align: center;
      font-size: 0.2526rem;
      color: #272b2d;
      line-height: 0.4rem;
      padding: 0.5263rem 0;
    }
    .case-title-ios{
      display: none;
       @media screen and (max-width: 540px) {
        display: block;
      text-align: center;
      color: #272b2d;
      font-size: 12px;
      padding: 10px 30px;


      }
    }
    .case-box {
      // width: 14.9474rem;
      height: 7.0526rem;
      margin: 0 auto;
      margin-bottom: 1.7684rem;
      @media screen and (max-width: 540px) {
        // display: none;
        padding: 30px 0 40px 0;
      }
      /deep/.el-carousel__container {
        height: 7.0526rem;
        margin: 0 auto;
        width: 12.8421rem;
        margin-bottom: 1.7684rem;
        @media screen and (max-width: 540px) {
          width: 82%;
          height: 180px;
        }
        .el-carousel__arrow--right {
          right: -1.0526rem;
          @media screen and (max-width: 540px) {
            right: -35px;
          }
        }
        .el-carousel__arrow--left {
          left: -1.0526rem;
          @media screen and (max-width: 540px) {
            left: -35px;
          }
        }
      }
      /deep/ .el-carousel__arrow {
        width: 0.5263rem;
        height: 0.5263rem;
        background-color: #fff;
        border: 2px solid #c6c6c6;
        @media screen and (max-width: 540px) {
          width: 28px;
          height: 28px;
        }
        i {
          font-size: 0.2105rem;
          font-weight: 700;
        }
        color: #c6c6c6;
      }
      /deep/ .el-carousel__indicators--horizontal {
        bottom: 0.9474rem;
        @media screen and (max-width: 540px) {
          bottom: 0;
        }
      }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        background-color: #e8e8e8;
        @media screen and (max-width: 540px) {
          height: 5px;
        }
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      .el-carousel__item {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        .cover {
          width: 100%;
          height: 100%;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .btn {
            position: absolute;
            background: url('../../assets/image/innovatc/play.png') no-repeat;
            background-size: 100% 100%;
            width: 100px;
            height: 100px;
            @media screen and (max-width: 540px) {
              height: 50px;
              width: 50px;
            }
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
          }
        }
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
  }
}
</style>
